import axios from 'axios';
import store from "@/js/store";
// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理

export const base = process.env.NODE_ENV == "production" ? 'https://shopapi.koipy.com' : '';

// 请求延时
axios.defaults.timeout = 20000
var storeTemp = store;
axios.interceptors.request.use(
    config => {
        var curTime = new Date()
        var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))

        if (storeTemp.state.token && (curTime < expiretime && storeTemp.state.tokenExpire)) {
            // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = "Bearer " + storeTemp.state.token;
        }

        saveRefreshtime();

        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// http response 拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {

        // 超时请求处理
        return ""; // 返回接口返回的错误信息
    }
);
const ToLogin = params => {
    store.dispatch("saveToken", "");
    store.dispatch("saveTokenExpire", "");
    window.localStorage.removeItem('user');
    window.location.href = '/login';
};


// 登录
export const requestLogin = params => {
    return axios.get(`${base}/wap/login/GetJwtToken`, {
        params: params
    }).then(res => res.data);
};

export const refreshToken = params => {
    return axios.get(`${base}/wap/login/RefreshToken`, {
        params: params
    }).then(res => res.data);
};

export const saveRefreshtime = params => {

    let nowtime = new Date();
    let lastRefreshtime = window.localStorage.refreshtime ? new Date(window.localStorage.refreshtime) : new Date(-1);
    let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))

    let refreshCount = 1; //滑动系数
    if (lastRefreshtime >= nowtime) {
        lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
        lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
        window.localStorage.refreshtime = lastRefreshtime;
    } else {
        window.localStorage.refreshtime = new Date(-1);
    }
};
//帐号
export const getOAuthUrl = () => {
    return axios.get(`${base}/wap/Login/GetOAuthUrl`);
};
export const weChatCallback = params => {
    return axios.get(`${base}/wap/Login/WeChatCallback`, {
        params: params
    });
};

// 商户发单


export const getShopData = params => {
    return axios.get(`${base}/wap/Shop/GetShopInfo`, {
        params: params
    });
};
export const getUserBusiness = params => {
    return axios.get(`${base}/wap/Shop/GetUserBusiness`, {
        params: params
    });
};

export const getShopInfo = params => {
    return axios.get(`${base}/wap/Shop/GetInfo`, {
        params: params
    });
};
export const orderAffirmReceipt = params => {
    return axios.get(`${base}/wap/Order/AffirmReceipt`, {
        params: params
    });
};
export const orderAffirmDelivery = params => {
    return axios.get(`${base}/wap/Order/AffirmDelivery`, {
        params: params
    });
};
export const getShopOrderList = params => {
    return axios.get(`${base}/wap/Order/GetShopOrderList`, {
        params: params
    });
};
export const orderAllExportData = params => {
    return axios.post(`${base}/wap/Order/OrderAllExportData`, params, {
        responseType: 'blob'
    });
};
export const getCashFlowList = params => {
    return axios.get(`${base}/wap/CashFlow/GetList`, {
        params: params
    });
};
//提现申请
export const sendShopPayout = params => {
    return axios.post(`${base}/wap/ShopPayout/post`, params);
};
export const getShopPayoutList = params => {
    return axios.get(`${base}/wap/ShopPayout/GetList`, {
        params: params
    });
};
export const getShopPayoutInfo = params => {
    return axios.get(`${base}/wap/ShopPayout/GetInfo`, {
        params: params
    });
};
export const ShopPayoutCancel = params => {
    return axios.get(`${base}/wap/ShopPayout/Cancel`, {
        params: params
    });
};
//产品管理
export const getProductList = params => {
    return axios.get(`${base}/wap/Product/GetList`, {
        params: params
    });
};
export const getProductInfo = params => {
    return axios.get(`${base}/wap/Product/Get`, {
        params: params
    });
};
export const editProduct = params => {
    return axios.put(`${base}/wap/Product/put`, params);
};